module.exports = __webpack_public_path__ + "static/media/izlozba (8).680c6c80.jpg";